<template>
  <div class="terms-of-conditions">
    I have read, understand, and accept Calvert Impact Capital's
    <a target="_blank" href="https://calvertimpact.org/terms-of-use">
      Terms of Use
    </a>,
    <a
      target="_blank"
      href="https://www.calvertimpactcapital.org/privacy#privacy"
    >
      Privacy Policy
    </a>, and
    <a target="_blank" href="https://www.calvertimpactcapital.org/prospectus">
      Community Investment Note Prospectus
    </a>, and our payment partner Dwolla's
    <a target="_blank" href="https://www.dwolla.com/legal/tos/?whitelabel">
      Terms of Service
    </a> and
    <a target="_blank" href="https://www.dwolla.com/legal/privacy?whitelabel">
    Privacy Policy
    </a>.
    <br /><br />
    I further agree that any interest check I receive for an amount less than $20.00
    that remains uncashed 365 days after issuance will be donated to Calvert Impact Capital
    and I will receive a donation receipt for that amount.
    I will be notified of the uncashed check three times prior to the donation.
    <br /><br />
    <template v-if="!hideStateDisclosures">
      <strong>
        <u>For Pennsylvania Residents</u>: Please note your right of refusal
        within two days of investing as described in the prospectus on
        <u>page iv</u>.
      </strong>
      <br /><br />
      For Tennessee Residents Only: I also acknowledge that I have 1. a gross
      annual income of at least $70,000 and a net worth of at least $70,000, or
      a net worth of at least $250,000, and 2. that I am not investing more than
      10% of my personal net worth (excluding my primary residence, home
      furnishings, and automobiles).
      <br /><br />
      For Washington State Residents Only: I also acknowledge that I am not
      investing more than 10% of my personal net worth, or joint net worth with
      my spouse or spousal equivalent, in Community Investment Notes. For this
      purpose, my net worth excludes the value of my primary residence and its
      furnishing, automobiles, and loans associated with them.
    </template>
  </div>
</template>

<script>
export default {
  name: 'TermOfConditions',
  props: {
    hideStateDisclosures: {
      default: false,
      type: Boolean,
    },
  },
};
</script>
<style scoped>
.terms-of-conditions {
  margin-top: -20px;
}
</style>



// WEBPACK FOOTER //
// TermsOfConditions.vue?f8f7d336